import sanitizeHtml from 'sanitize-html'

import { Translation } from 'cng-common/features/translations'
import { deleteParamsFromUrl, getUrlWithParams } from 'core-components/helpers/url'
import { Tooltip } from 'core-components/library/tooltip'
import { P360_PAGE_URL, PID_URL } from 'partner360/configs'
import { getUrlParamsForDeleting } from 'partner360/helpers/routing/getUrlParamsForDeleting'
import { TRANSLATION_KEYS } from 'partner360/widgets/gp360Administration/translations'

interface IP360LinkWrapperProps {
  partnerId: string | null
  text: string | null
}

export const P360LinkWrapper = ({ partnerId, text }: IP360LinkWrapperProps) => {
  if (!text) {
    return null
  }

  return (
    <Tooltip
      tipContent={() => (
        <Translation text={TRANSLATION_KEYS.globalPartnerDetails.p360LinkWrapper} />
      )}
    >
      <a
        href={sanitizeHtml(
          getUrlWithParams(
            {
              page: P360_PAGE_URL,
              [PID_URL]: partnerId,
            },
            deleteParamsFromUrl(getUrlParamsForDeleting(location.pathname))
          )
        )}
        target={'_blank'}
        rel="noreferrer"
      >
        <div>{text}</div>
      </a>
    </Tooltip>
  )
}
